import api from '../api';

/**
 * Serviço para buscar todos os logos de uma rede específica
 */
const fetchLogos = async (idRede) => {
  if (!idRede) {
    throw new Error('ID da rede é obrigatório');
  }

  try {
    const apiUrl = process.env.REACT_APP_API_BASE_70;
    
    const response = await api.get(`${apiUrl}?id_rede=${idRede}&tipo=logo`);
    
    if (response.data && response.data.imagens) {
      return {
        success: true,
        total: response.data.total,
        logos: response.data.imagens.map(logo => ({
          id: logo.file_id,
          nome: logo.nome_arquivo,
          descricao: logo.descricao || '',
          nomeLogo: logo.nome || '',
          url: logo.url,
          thumbnailUrl: logo.thumbnail_url || logo.url,
          dataUpload: new Date(logo.data_upload)
        }))
      };
    }
    
    return {
      success: false,
      message: 'Formato de resposta inválido'
    };
  } catch (error) {
    console.error('Erro ao buscar logos:', error);
    
    return {
      success: false,
      message: error.response?.data?.error || 'Erro ao buscar logos',
      error
    };
  }
};

export default fetchLogos; 